
import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../../components/ui/table";
import {  GstSession } from "../../../types/CustomerInterface";

interface gstSessionProps{
  gstDetails?:GstSession[]
}

export const GstDetailsSection: React.FC<gstSessionProps> = ({ gstDetails }) => {

  const formatDatein = (d?: string) => {
    if (!d) return "N/A";
  
    const date = new Date(d);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
  
    return `${day}/${month}/${year}`;
  };

  return (
    <section className="mb-6">
      <div className="flex items-center gap-3 mb-6">
        {/* <div className="w-8 h-8 bg-orange-600 rounded-full flex items-center justify-center">
          <span className="text-white font-bold text-sm">7</span>
        </div> */}
        <h3 className="text-xl font-bold text-[#9e7926]">GST Details</h3>
      </div>

      <div className="bg-white rounded-lg border shadow-sm overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-gray-50">
              <TableHead className="font-semibold text-gray-900">GSTIN</TableHead>
              <TableHead className="font-semibold text-gray-900">State</TableHead>
              <TableHead className="font-semibold text-gray-900">Registration Date</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {gstDetails?.map((gst, index) => (
              <TableRow key={index} className="hover:bg-gray-50">
                <TableCell className="font-medium font-mono text-sm">{gst.gstin}</TableCell>
                <TableCell>{gst.state}</TableCell>
                <TableCell>{formatDatein(gst.registration)}</TableCell>
                
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </section>
  );
};
